<template>
  <div class="container">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <form @submit.prevent="login">
        <card class="card-login card-white">
          <template slot="header">
            <!-- <img src="img/card-primary.png" alt="" />
            <img class="card-title" src="img/VECTOLABS.png" width="70%" alt />
            <h1 class="card-title">Log in</h1>-->
            <div style="text-align: center; padding-top: 5%; ">
              <img class="card-title" src="img/tabicon.png" width="90%" alt />
            </div>
            <div>
              <!-- <img class="card-title" src="img/card-danger.png" alt /> -->
            </div>
            <h6
              style="color: #73786F; font-size: 100%; text-align: center; padding-top: 1%;"
            >
              Sign In to continue
            </h6>
          </template>

          <div>

             
            <base-input
              v-validate="'required'"
              v-model="model.empid"
              placeholder="Employee ID"
              addon-left-icon="tim-icons icon-single-02"
            ></base-input>

            <base-input
              v-validate="'required|min:5'"
              name="password"
              :error="getError('password')"
              v-model="model.password"
              type="password"
              placeholder="Password"
              addon-left-icon="tim-icons icon-lock-circle"
            ></base-input>
          </div>

          <div slot="footer">
            <!-- <router-link class="link footer-link" to="/lightpage"> -->
            <base-button
              v-if="!loading"
              v-on:click="login()"
              native-type="submit"
              type="success"
              class="mb-3"
              size="lg"
              block
              >Login</base-button
            >
            <p style="color:red" v-html="model.message"></p>
            <!-- </router-link> -->
            <div class="d-flex justify-content-center">
              <circle-8 v-if="loading"></circle-8>
            </div>
            <div class="pull-left">
              <h6>
                <!-- <router-link class="link footer-link" to="/register">
                  Create Account
                </router-link>-->
              </h6>
            </div>

            <div class="pull-right">
              <!-- <h6><a href="#pablo" class="link footer-link">Need Help?</a></h6> -->
            </div>
          </div>
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import { Alert } from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import util from "../../util/util";

export default {
  name: "Login",
  components: {
    Circle8
  },
  data() {
    return {
      loading: false,
      model: {
        empid: "",
        password: "",
        message: ""
      }
    };
  },
  methods: {
    login() {
      this.loading = true;
      let payload = {
        empid: this.model.empid,
        password: this.model.password
      };

      // if (navigator.onLine) {
      this.$http
        .post(":9992/auth/staff/login", payload)
        .then(res => {
          console.log(res);
          this.loading = false;
          if (res.error) {
            //pupout oeror
            console.log(res.message);
            this.model.message = res.message;
          } else {
           
            //login OK!
            console.log(res.message.jwt_token);
            sessionStorage.setItem("token", res.message.jwt_token);
            
            //ping goken 
            util.tokenPing()

            // GET THE ACCESS MODULE FROM TOKEN
            let access = JSON.parse(atob(res.message.jwt_token.split(".")[1]))
              .namespace;

            let roles = JSON.parse(atob(res.message.jwt_token.split(".")[1]))
              .roles;
      
            // ROUTE USER BASED ON WHAT MODULE IN FIRST ARRAY
            if (roles == "ALLACCESS") {
              this.$router.push("/UserManagement");
            } else {
              if (access[0] == "GREENCARD") {
                this.$router.push("/Greencard/Overview");
              } else if (access[0] == "FLEET") {
                this.$router.push("/Fleet/Overview");
              } else if (access[0] == "INCIDENT") {
                this.$router.push("/IncidentReport/IncidentOverview");
              } else if (access[0] == "ATTENDANCE") {
                if (roles == "SUPERVISOR"){
                  this.$router.push("Attendance/ScheduleEdit");
                }else {
                  this.$router.push("/Attendance/AttendanceOverview");
                }
              } else if (access[0] == "ASSET") {
                this.$router.push("/Asset/AssetOverview");
              }
            }

            //kne decode and check for acccess domain
          }
        })
        .catch(err => {
          this.model.message = "Wrong username or password";
          console.log(err);
          // swal({
          //   title: "Wrong employee ID or password!",
          //   type: "error",
          //   confirmButtonClass: "btn btn-success btn-fill",
          //   confirmButtonText: "Okay",
          //   buttonsStyling: false
          // });
        });
      // } else {
      //   swal({
      //     type: "error",
      //     title: "Oops... You have no internet conncetion!"
      //   });
      // }
    },
    loginSuccessful(req) {
      if (!req.data.token) {
        this.loginFailed();
        return;
      }

      localStorage.token = req.data.token;
      this.error = false;

      // this.$router.replace(this.$route.query.redirect || "/lightpage");
    },
    loginFailed() {
      this.error = "Login failed!";
      // this.message = res.message;
      delete localStorage.token;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    }
  },
  created() {
    // this.appKey();
    // const loggedIn = sessionStorage.getItem("token");
    // if (loggedIn) {
    //   this.$router.push("/dashboard");
    // }
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
